import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/request/request'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'reset-css'
import 'amfe-flexible' //引入rem自适应
import VueClipboard from 'vue-clipboard2'

import VConsole from 'vconsole'
if (process.env.NODE_ENV !== 'production') {
    const vConsole = new VConsole()
}

Vue.use(VueClipboard)
// import VeRing from 'v-charts/lib/ring.common.js'
// import VeLine from 'v-charts/lib/line.common.js'
// // 引入echarts
// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts
// import '@/assets/icon/iconfont.css'


// Vue.component(VeRing.name, VeRing)
// Vue.component(VeLine.name, VeLine)

Vue.use(Vant)
Vue.config.productionTip = false

Vue.filter('Rbm', val => {
    let newval = Number(val)
    return (newval / 100).toFixed(2)
})
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
